const state = {
    error: false,
    success: false,
    loader: false,
    message: '',
    authError: false,
    perm_error: false,
    validation_error: {}
}

const actions = {
    ADD_PERM_ERROR({ commit }, error) {
        commit('SET_PERM_ERROR', error)
    },

    PERM_CLEAR({ commit }) {
        commit('SET_PERM_CLEAR')
    },

    ADD_ERROR({ commit }, error) {
        commit('SET_ERROR', error)
    },

    CLEAR_ERROR({ commit }) {
        commit('CLEAR_ERROR')
    },

    LOADER_START({ commit }) {
        commit('SET_LOADER_START')
    },

    LOADER_STOP({ commit }) {
        commit('SET_LOADER_STOP')
    },

    ADD_SUCCESS({ commit }, success) {
        commit('SET_SUCCESS', success)
    },

    CLEAR_SUCCESS({ commit }) {
        commit('CLEAR_SUCCESS')
    },

    AUTH_ERROR({ commit }) {
        commit('ERROR_AUTH')
    },

    AUTH_SUCCESS({ commit }) {
        commit('AUTH_SUCCESS')
    }
}

const mutations = {
    SET_PERM_ERROR(state, error) {
        state.perm_error = true
        state.message = error
    },

    SET_PERM_CLEAR(state) {
        state.perm_error = false
    },

    ADD_PERM_ERROR(state) {
        state.perm_error = true
    },

    SET_LOADER_START(state) {
        state.loader = true
    },

    SET_LOADER_STOP(state) {
        state.loader = false
    },

    SET_ERROR(state, error) {
        state.error = true
        state.message = error
    },

    SET_SUCCESS(state, success) {
        state.success = true
        state.message = success
    },

    CLEAR_ERROR(state) {
        state.error = false
        state.message = ''
    },

    CLEAR_SUCCESS(state) {
        state.success = false
        state.message = ''
    },

    ERROR_AUTH(state) {
        state.authError = true
    },

    AUTH_SUCCESS() {
        state.authError = false
    },
    
    SET_VALID_ERROR(state, error) {
        state.validation_error = error
    },
    
    CLEAR_VALID_ERROR(state) {
        state.validation_error = {}
    }
}

const getters = {
    perm_error: state => ({perm_error: state.perm_error, message: state.message}),
    error: state => ({ error: state.error, message: state.message }),
    success: state => ({ success: state.success, message: state.message }),
    authError: state => state.authError,
    loader: state => state.loader,
    validation_error: state => state.validation_error
}

export default {
    state,
    actions,
    mutations,
    getters
}
